import { t } from '@i18n/i18n';

import React, { useState } from 'react';
import './styles/nav-mobile.scss';
import useLanguageLinks from './useLanguageLinks';
import LangA from '../../i18n/LangA';
import { useI18nInitNamespace } from '../../i18n/useI18nInitNamespace';
import CloudflareImage from '../cloudflare-image/CloudflareImage';
import mobileNavTranslations from '@i18n/translations/components/navigation/nav.json';
import { loginUrl } from '../../i18n/environments';

// import BlogIcon from '../../images/navigation/blog-icon.webp';
// import CaseStudyIcon from '../../images/navigation/case-study-icon.webp';
// import ContactPhoneIcon from '../../images/navigation/contact-phone-icon.webp';
// import DataIcon from '../../images/navigation/data-icon.webp';
// import DrawerIcon from '../../images/navigation/drawer-icon.webp';
// import EmailFinderIcon from '../../images/navigation/email-finder-icon.webp';
// import EmailScoreIcon from '../../images/navigation/email-score-icon.webp';
// import GearIcon from '../../images/navigation/gear-icon.webp';
// import HeartbeatIcon from '../../images/navigation/heartbeat-icon.webp';
// import MediaKitIcon from '../../images/navigation/media-kit-icon.webp';
// import NewsIcon from '../../images/navigation/news-icon.webp';
// import PartnerIcon from '../../images/navigation/partners-icon.webp';
// import PhoneIcon from '../../images/navigation/phone-icon.webp';
// import ProfileIcon from '../../images/navigation/profile-icon.webp';
// import SecurityIcon from '../../images/navigation/security-icon.webp';
import LeftArrow from '../../images/navigation-icons/mobile-nav-left-arrow.png';
import RightArrow from '../../images/navigation-icons/mobile-nav-right-arrow.png';
import Xicon from '../../images/navigation-icons/mobile-nav-close.png';
// import StarIcon from '../../images/navigation/star-icon.webp';
// import SuitcaseIcon from '../../images/navigation/suitcase-icon.webp';
// import ValidationIcon from '../../images/navigation/validation-icon.webp';
// import DmarcIcon from '@images/icons/dmarc-starter.png';
import NavListItem from './navigation-components/nav-list-item';
// import OnlineIcon from '../../images/navigation/event_nav_icon.png';
// import SettingsIcon from '../../images/icons/settings.inline.webp';
// import GuidesIcon from '../../images/navigation/case_studies_nav.png';
// import ReviewsIcon from '../../images/navigation/reviews_nav.png';
// import ServerIcon from '../../images/icons/server_icon_check_blue.png';
import StyledLink from '../StyledLink/StyledLink';
// import WarmupIcon from '../../images/icons/icon-warmup-blue.png';
// import ToolsIcon from '../../images/icons/toolkit-icon-blue.png';
import ABHeader from '../header/ABHeader/ABHeader';

const NavMobile = ({ setMobileNav, customNavElements = [], customPricingLink = '', handleAction, color, registerUrlDestination = '' }) => {
  useI18nInitNamespace('mobileNav', mobileNavTranslations, true);
  const languageLinks = useLanguageLinks();

  const [openDropdown, setOpenDropdown] = useState('firstMenu');
  const [prevDropdown, setPrevDropdown] = useState('');

  const handleToggle = (e, hasDropdown, dropdownId) => {
    hasDropdown && e.preventDefault();
    setPrevDropdown(openDropdown);
    setOpenDropdown(dropdownId);
  };
  const handleBackClick = () => {
    setOpenDropdown(prevDropdown);
    setPrevDropdown(prevDropdown === 'firstMenu' ? '' : 'firstMenu');
  };

  const handleExitClick = () => {
    setOpenDropdown('firstMenu');
    setMobileNav();
  };
  const menu = [
    {
      linkText: t('a_Products'),
      title: t('You_put'),
      href: '/',
      hasDropdown: true,
      dropdownId: 'products_dropdown',
      class: 'products',
      titleId: 'head_navigation_products',
      customTitle: 'products',
    },
    {
      class: 'enterprise',
      linkText: t('Solutions'),
      title: t('Solutions'),
      href: '/',
      hasDropdown: true,
      titleId: 'head_navigation_enterprise',
      customTitle: 'enterprise',
      dropdownId: 'enterprise_dropdown',
    },
    {
      class: 'pricing',
      linkText: t('a_Pricing'),
      title: t('ZeroBounce_Pricing'),
      href: customPricingLink || '/email-validation-pricing/',
      hasDropdown: false,
      titleId: 'head_navigation_pricing',
      customTitle: 'pricing',
    },
    {
      class: 'resources',
      hasDropdown: true,
      href: '/docs/',
      linkText: t('a_Resources'),
      title: t('ZeroBounce_Documentation'),
      titleId: 'head_navigation_resources',
      dropdownId: 'resources_dropdown',
      customTitle: 'resources',
    },
    {
      class: 'company',
      hasDropdown: true,
      href: '/why-us/',
      linkText: t('a_Company'),
      title: t('a_Company'),
      titleId: 'head_navigation_company',
      dropdownId: 'company_dropdown',
      customTitle: 'company',
    },
  ];

  const submenu = [
    {
      title: t('p_PRODUCTS'),
      titleId: 'products_navigation_products',
      dropdownId: 'products_dropdown',
      items: [
        {
          linkText: t('Email_Validation'),
          subText: t('Clean_your1'),
          title: t('Clean_your'),
          href: '/services/email-validation/',
          // img: ValidationIcon,
          headId: 'navigation_validation_title',
          subTextId: 'navigation_validation_text',
          iconId: 'navigation_validation_icon',
        },
        {
          linkText: t('Email_Activity'),
          subText: t('Discover_most'),
          title: t('Find_and'),
          href: '/services/activity-data/',
          // img: DataIcon,
          headId: 'navigation_activity_title',
          subTextId: 'navigation_activity_text',
          iconId: 'navigation_activity_icon',
        },
        {
          linkText: t('Email_Score'),
          subText: t('AI_email'),
          title: t('Email_scoring'),
          href: '/services/email-scoring/',
          // img: EmailScoreIcon,
          headId: 'navigation_scoring_title',
          subTextId: 'navigation_scoring_text',
          iconId: 'navigation_scoring_icon',
        },
        {
          linkText: t('warmup_title'),
          subText: t('warmup_text'),
          title: t('warmup_title'),
          href: '/services/email-warmup/',
          // img: WarmupIcon,
          width: '20',
          height: '25',
          headId: 'navigation_warmup_title',
          subTextId: 'navigation_warmup_text',
          iconId: 'navigation_warmup_icon',
        },
        {
          linkText: t('dmarc_title'),
          subText: t('dmarc_text'),
          title: t('dmarc_title'),
          href: '/services/dmarc-monitor/',
          // img: DmarcIcon,
          headId: 'navigation_dmarc_title',
          subTextId: 'navigation_dmarc_text',
          iconId: 'navigation_dmarc_icon',
        },
        {
          linkText: t('Blacklist_Monitor'),
          subText: t('Real_time'),
          title: t('Get_notifications'),
          href: '/services/blacklist-monitoring/',
          // img: HeartbeatIcon,
          headId: 'navigation_blacklist_title',
          subTextId: 'navigation_blacklist_text',
          iconId: 'navigation_blacklist_icon',
        },
        {
          linkText: t('inbox_placement_test'),
          subText: t('test_inbox'),
          title: t('Test_for'),
          href: '/services/inbox-placement-test',
          // img: DrawerIcon,
          headId: 'navigation_inbox_title',
          subTextId: 'navigation_inbox_text',
          iconId: 'navigation_inbox_icon',
        },
        {
          linkText: t('email_server_test'),
          subText: t('diagnose_email'),
          title: t('Test_for'),
          href: '/services/email-server-test/',
          // img: ServerIcon,
          headId: 'navigation_testing_title',
          subTextId: 'navigation_testing_text',
          iconId: 'navigation_testing_icon',
        },
        {
          linkText: t('Email_Finder'),
          subText: t('Email_Finder_Description'),
          title: t('Email_Finder'),
          href: '/services/email-finder/',
          // img: EmailFinderIcon,
          headId: 'navigation_finder_title',
          subTextId: 'navigation_finder_text',
          iconId: 'navigation_finder_icon',
        },
        {
          linkText: t('tools_text'),
          subText: t('tools_desc'),
          title: t('tools_text'),
          href: '/email-deliverability-tools/',
          // img: ToolsIcon,
          width: '26',
          height: '23',
          headId: 'navigation_tools_title',
          subTextId: 'navigation_tools_text',
          iconId: 'navigation_tools_icon',
        },

        {
          linkText: 'API',
          title: 'API',
          titleId: 'products_navigation_api',
          itemHasDropdown: true,
          dropdownId: 'services_api_dropdown',
        },
        {
          linkText: t('p_FREE_TOOLS'),
          title: t('p_FREE_TOOLS'),
          titleId: 'products_navigation_tools',
          itemHasDropdown: true,
          dropdownId: 'free_tools_dropdown',
        },
      ],
    },
    {
      title: t('Solutions'),
      titleId: 'head_navigation_enterprise',
      dropdownId: 'enterprise_dropdown',
      items: [
        {
          linkText: t('a_Enterprise'),
          subText: null,
          title: t('a_Enterprise'),
          href: '/enterprise/',
          img: null,
          headId: 'navigation_evaluator_title',
        },
        {
          linkText: t('Agencies'),
          subText: null,
          title: t('Agencies'),
          href: '/solutions/agencies/',
          img: null,
          headId: 'navigation_verifier_title',
        },
        {
          linkText: t('Business'),
          subText: null,
          title: t('Business'),
          href: '/solutions/business-development/',
          img: null,
          headId: 'navigation_checker_title',
        },
        {
          linkText: t('class_action_settlement_email_validation'),
          subText: null,
          title: t('class_action_settlement_email_validation'),
          href: '/solutions/class-action-settlement-email-validation/',
          img: null,
          headId: 'navigation_class_action_settlement_email_validation_title',
        },
        {
          linkText: t('Developers'),
          subText: null,
          title: t('Developers'),
          href: '/solutions/developers/',
          img: null,
          headId: 'navigation_send_time_title',
        },
        {
          linkText: t('Email_marketing'),
          subText: null,
          title: t('Email_marketing'),
          href: '/solutions/email-marketing/',
          img: null,
          headId: 'navigation_send_time_title1',
        },
        {
          linkText: 'SMB',
          subText: null,
          title: 'SMB',
          href: '/solutions/smb/',
          img: null,
          headId: 'navigation_send_time_title2',
        },
      ],
    },
    {
      title: t('a_Resources'),
      titleId: 'head_navigation_resources_dropdown',
      dropdownId: 'resources_dropdown',
      items: [
        {
          linkText: t('Blog'),
          subText: null,
          title: t('Blog'),
          href: 'https://www.zerobounce.net/blog',
          // img: BlogIcon,
          headId: 'navigation_blog_title',
          subTextId: 'navigation_blog_text',
          iconId: 'navigation_blog_icon',
        },
        {
          linkText: t('Integrations'),
          subText: null,
          title: t('Integrations'),
          href: '/integrations/',
          // img: GearIcon,
          headId: 'navigation_integrations_title',
          subTextId: 'navigation_integrations_text',
          iconId: 'navigation_integrations_icon',
        },
        {
          linkText: t('Case_Studies1'),
          subText: null,
          title: t('Case_Studies1'),
          href: '/case-studies/',
          // img: CaseStudyIcon,
          headId: 'navigation_studies_title',
          subTextId: 'navigation_studies_text',
          iconId: 'navigation_studies_icon',
        },
        {
          linkText: t('email_guides'),
          subText: null,
          title: t('email_guides'),
          href: '/email-guides/',
          // img: GuidesIcon,
          titleId: 'email_guides',
          dropdownId: 'email_guides_dropdown',
          iconId: 'email_guides_icon',
          hasSmallDropdown: false,
        },
        {
          linkText: t('ZeroBounce_iOS_App'),
          subText: null,
          title: t('ZeroBounce_iOS_App'),
          href: '/ios/',
          // img: PhoneIcon,
          headId: 'navigation_ios_title',
          subTextId: 'navigation_ios_text',
          iconId: 'navigation_ios_icon',
        },
        {
          linkText: t('SUPPORT'),
          title: t('SUPPORT'),
          titleId: 'resources_navigation_support',
          itemHasDropdown: true,
          dropdownId: 'support_dropdown',
        },
        {
          linkText: t('Api'),
          title: t('Api'),
          titleId: 'resources_navigation_api',
          itemHasDropdown: true,
          dropdownId: 'api_dropdown',
        },
        {
          linkText: t('Email_Types'),
          title: t('Email_Types'),
          titleId: 'resources_navigation_types',
          itemHasDropdown: true,
          dropdownId: 'email_types_dropdown',
        },
        {
          linkText: t('Email_Deliverability1'),
          title: t('Email_Deliverability1'),
          titleId: 'resources_navigation_other',
          itemHasDropdown: true,
          dropdownId: 'other_dropdown',
        },
      ],
    },
    {
      title: t('a_Company'),
      titleId: 'head_navigation_company',
      dropdownId: 'company_dropdown',
      items: [
        {
          linkText: t('About_ZeroBounce'),
          subText: null,
          title: t('ZeroBounce_Team'),
          href: '/zerobounce-team/',
          // img: ProfileIcon,
          headId: 'navigation_about_title',
          subTextId: 'navigation_about_text',
          iconId: 'navigation_about_icon',
        },
        {
          linkText: t('Why_us'),
          subText: null,
          title: t('Why_us_info'),
          href: '/why-us/',
          // img: StarIcon,
          headId: 'navigation_why_us_title',
          subTextId: 'navigation_why_us_text',
          iconId: 'navigation_why_us_icon',
        },
        {
          linkText: t('Media_Kit'),
          subText: null,
          title: t('ZeroBounce_Press'),
          href: '/media-press-kit/',
          // img: MediaKitIcon,
          headId: 'navigation_press_title',
          subTextId: 'navigation_press_text',
          iconId: 'navigation_press_icon',
        },
        {
          linkText: t('Newsroom'),
          subText: null,
          title: t('Newsroom_Archives'),
          href: 'https://www.zerobounce.net/blog/category/newsroom',
          // img: NewsIcon,
          headId: 'navigation_newsroom_title',
          subTextId: 'navigation_newsroom_text',
          iconId: 'navigation_newsroom_icon',
        },
        {
          linkText: t('Jobs'),
          subText: null,
          title: t('Career_Opportunities'),
          href: '/careers/',
          // img: SuitcaseIcon,
          headId: 'navigation_jobs_title',
          subTextId: 'navigation_jobs_text',
          iconId: 'navigation_jobs_icon',
        },
        {
          linkText: t('Partners'),
          subText: null,
          title: t('ZeroBounce_Partnership'),
          href: '/partners/',
          // img: PartnerIcon,
          headId: 'navigation_partners_title',
          subTextId: 'navigation_partners_text',
          iconId: 'navigation_partners_icon',
        },
        {
          linkText: t('Contact'),
          subText: null,
          title: t('ZeroBounce_Contact'),
          href: '/contact-us/',
          // img: ContactPhoneIcon,
          headId: 'navigation_contact_title',
          subTextId: 'navigation_contact_text',
          iconId: 'navigation_contact_icon',
        },
        {
          linkText: t('Security'),
          subText: null,
          title: t('ZeroBounce_Security'),
          href: '/security/',
          // img: SecurityIcon,
          headId: 'navigation_security_title',
          subTextId: 'navigation_security_text',
          iconId: 'navigation_security_icon',
        },
        {
          linkText: t('Events'),
          subText: null,
          title: t('ZeroBounce_Events'),
          href: null,
          // img: OnlineIcon,
          headId: 'navigation_events_title',
          subTextId: 'navigation_events_text',
          iconId: 'navigation_events_icon',
          hasSmallDropdown: true,
          subMenu: [
            {
              linkText: t('upcoming_events'),
              subText: null,
              title: t('upcoming_events'),
              href: '/events/',
              img: null,
              headId: 'navigation_upcoming_events_title',
            },
            {
              linkText: t('on_demand'),
              subText: null,
              title: t('on_demand'),
              href: '/events/#on-demand',
              img: null,
              headId: 'navigation_on_demand_title',
            },
            {
              linkText: t('Email_Day1'),
              subText: null,
              title: t('Email_Day1'),
              href: '/email-day/',
              img: null,
              headId: 'navigation_email_day_title',
            },
          ],
        },
        {
          linkText: t('Updates'),
          subText: null,
          title: t('ZeroBounce_Updates'),
          href: '/updates/',
          // img: SettingsIcon,
          headId: 'navigation_updates_title',
          subTextId: 'navigation_updates_text',
          iconId: 'navigation_updates_icon',
        },
        {
          linkText: t('ZeroBounce_Reviews'),
          subText: null,
          title: t('ZeroBounce_Reviews'),
          href: '/email-validation-reviews/',
          //  img: ReviewsIcon,
          headId: 'navigation_reviews_title',
          subTextId: 'navigation_reviews_text',
          iconId: 'navigation_reviews_icon',
        },
      ],
    },
  ];

  const subSubmenu = [
    {
      title: t('p_FREE_TOOLS'),
      titleId: 'products_navigation_products',
      titleHref: '',
      dropdownId: 'free_tools_dropdown',
      items: [
        {
          linkText: t('overview'),
          subText: null,
          title: t('overview'),
          href: '/free-email-tools/',
          img: null,
          headId: 'navigation_verifier_overview',
        },
        {
          linkText: t('Free_Email_Verifier'),
          subText: null,
          title: t('Free_Email_Verifier'),
          href: '/free-email-verifier/',
          img: null,
          headId: 'navigation_verifier_title',
        },
        {
          linkText: t('Free_List_Evaluator'),
          subText: null,
          title: t('Free_List_Evaluator'),
          href: '/email-list-evaluator/',
          img: null,
          headId: 'navigation_evaluator_title',
        },
        {
          linkText: t('Blacklist_Checker'),
          subText: null,
          title: t('Blacklist_Checker'),
          href: '/services/blacklist-checker/',
          img: null,
          headId: 'navigation_checker_title',
        },

        {
          linkText: t('dmarc_checker'),
          subText: null,
          title: t('dmarc_checker'),
          href: '/dmarc-checker/',
          img: null,
          headId: 'navigation_dmarc_checker_title',
        },
      ],
    },
    {
      title: 'API',
      titleId: 'services_navigation_api',
      dropdownId: 'services_api_dropdown',
      items: [
        {
          linkText: t('api_services'),
          subText: null,
          title: t('api_services'),
          href: '/api/',
          img: null,
          headId: 'navigation_api_title',
        },
        {
          linkText: t('Email_Validation_api'),
          subText: null,
          title: t('Email_Validation_api'),
          href: '/api/email-validation-api/',
          img: null,
          headId: 'navigation_verification_api_title',
        },
        {
          linkText: t('Email_Finder_API'),
          subText: null,
          title: t('Email_Finder_API'),
          href: '/api/email-finder-api/',
          img: null,
          headId: 'navigation_finder_api_title',
        },
      ],
    },
    {
      title: t('SUPPORT'),
      titleId: 'resources_navigation_support',
      dropdownId: 'support_dropdown',
      items: [
        {
          linkText: t('Documentation'),
          subText: null,
          title: t('Documentation'),
          href: '/docs/',
          img: null,
          headId: 'navigation_documentation_title',
        },
        {
          linkText: t('Help_Desk'),
          subText: null,
          title: t('Help_Desk'),
          href: '/contact-us/',
          img: null,
          headId: 'navigation_help_desk_title',
        },
        {
          linkText: t('FAQ'),
          subText: null,
          title: t('FAQ'),
          href: '/docs/frequently-asked-questions/',
          img: null,
          headId: 'navigation_faq_title',
        },
      ],
    },
    {
      title: t('Api'),
      titleId: 'resources_navigation_api',
      dropdownId: 'api_dropdown',
      items: [
        {
          linkText: t('Quickstart'),
          subText: null,
          title: t('Quickstart'),
          href: '/docs/',
          img: null,
          headId: 'navigation_quickstart_title',
        },
        {
          linkText: t('AI_Scoring'),
          subText: null,
          title: t('AI_Scoring'),
          href: '/docs/ai-scoring-api/',
          img: null,
          headId: 'navigation_ai_scoring_title',
        },
        {
          linkText: t('API_Dashboard'),
          subText: null,
          title: t('API_Dashboard'),
          href: '/docs/api-dashboard/',
          img: null,
          headId: 'navigation_dashboard_title',
        },
        {
          linkText: t('API_Wrappers'),
          subText: null,
          title: t('API_Wrappers'),
          href: '/docs/zerobounce-api-wrappers/',
          img: null,
          headId: 'navigation_wrappers_title',
        },
        {
          linkText: t('API_Status'),
          subText: null,
          title: t('API_Status'),
          href: 'https://status.zerobounce.net',
          img: null,
          headId: 'navigation_api_status_title',
        },
      ],
    },
    {
      title: t('Email_Types'),
      titleId: 'resources_navigation_types',
      dropdownId: 'email_types_dropdown',
      items: [
        {
          linkText: t('Spam_Traps'),
          title: t('Spam_Traps'),
          href: '/spam-traps/',
          img: null,
          headId: 'navigation_spam_traps_title',
        },
        {
          linkText: t('Catch-all_Emails'),
          title: t('Catch-all_Emails'),
          href: '/catch-all-emails/',
          img: null,
          headId: 'navigation_catch_all_emails_title',
        },
        { linkText: t('Abuse_Email'), title: t('Abuse_Email'), href: '/abuse-emails/', img: null, headId: 'navigation_abuse_emails_title' },
        {
          linkText: t('Disposable_Email'),
          title: t('Disposable_Email'),
          href: '/disposable-emails/',
          img: null,
          headId: 'navigation_disposable_title',
        },
        {
          linkText: t('Clean_Email'),
          title: t('Clean_Email'),
          href: '/clean-email/',
          img: null,
          headId: 'navigation_clean_email_title',
        },
        {
          linkText: t('no_reply_emails'),
          title: t('no_reply_emails'),
          href: '/no-reply-emails/',
          img: null,
          headId: 'navigation_no_reply_emails_title',
        },
        {
          linkText: t('bounced_emails'),
          title: t('bounced_emails'),
          href: '/bounced-emails/',
          img: null,
          headId: 'navigation_bounced_emails_title',
        },
        {
          linkText: t('invalid_emails'),
          title: t('invalid_emails'),
          href: '/invalid-emails/',
          img: null,
          headId: 'navigation_invalid_emails_title',
        },
      ],
    },
    {
      title: t('Email_Deliverability1'),
      titleId: 'resources_navigation_other',
      dropdownId: 'other_dropdown',
      items: [
        {
          linkText: t('Email_Deliverability1'),
          subText: null,
          title: t('Email_Deliverability1'),
          href: '/email-deliverability/',
          img: null,
          headId: 'navigation_deliverability_title',
        },
        {
          linkText: t('bounce_rates_email_deliverability'),
          subText: null,
          title: t('bounce_rates_email_deliverability'),
          href: '/bounce-rates-email-deliverability/',
          img: null,
          headId: 'navigation_bounce_rates_title',
        },
        {
          linkText: t('anti_greylisting'),
          subText: null,
          title: t('anti_greylisting'),
          href: '/anti-greylisting/',
          img: null,
          headId: 'navigation_anti_greylisting_title',
        },
        {
          linkText: t('Mailchimp_Omnivore'),
          subText: null,
          title: t('Mailchimp_Omnivore'),
          href: '/mailchimp-omnivore/',
          img: null,
          headId: 'navigation_deliverability_title',
        },
        {
          linkText: t('Email_Decay'),
          subText: null,
          title: t('Email_Decay'),
          href: '/email-list-decay/',
          img: null,
          headId: 'navigation_decay_title',
        },
        {
          linkText: t('Email_statistics'),
          subText: null,
          title: t('Email_statistics'),
          href: '/email-statistics-report/',
          img: null,
          headId: 'navigation_decay_title',
        },
        {
          linkText: t('testing_deliverability'),
          subText: null,
          title: t('testing_deliverability'),
          href: '/test-email-address-deliverability-guide/',
          img: null,
          headId: 'navigation_testing_deliverability_title',
        },
      ],
    },
  ];

  const filteredMenu = customNavElements.length > 0 ? menu.filter((item) => customNavElements.includes(item.customTitle)) : menu;

  return (
    <nav className="nav-mobile">
      <div className="buttons_container">
        <button className="nav-trigger-close" onClick={() => handleExitClick()} aria-label="Close the menu">
          <CloudflareImage src={Xicon} width="14" height="14" />
        </button>
        {openDropdown && openDropdown !== 'firstMenu' && (
          <button className="back_button_nav" onClick={() => handleBackClick()}>
            <CloudflareImage src={LeftArrow} width="8" height="13" />
            Back
          </button>
        )}
      </div>

      {openDropdown === 'firstMenu' && (
        <div className="mobile_nav_ul" id="firstMenu">
          {filteredMenu.map(({ linkText, title, href, hasDropdown, dropdownId, titleId }, index) => (
            <div key={`mobile_menu_${index}`} className="mobile_nav_li">
              <LangA
                className="main_mobile-link"
                id={titleId}
                href={href}
                title={title}
                onClick={(e) => handleToggle(e, hasDropdown, dropdownId)}
              >
                {linkText}
                {hasDropdown && (
                  <span>
                    <CloudflareImage src={RightArrow} height="15" width="9" />
                  </span>
                )}
              </LangA>
            </div>
          ))}

          <div className="register_li">
            <ABHeader registerUrlDestination={registerUrlDestination} isAuthenticated={false} />
            {/* <LangA
              style={{ background: color }}
              id="navigation_mobile_login_button"
              rel="nofollow"
              className="btn btn--primary is-small text-bold"
              onClick={(e) => handleAction(e, '', true, ({ param }) => (window.location.href = registerUrlDestination + param))}
            >
              {t('a_Sign_Up_Free')}
            </LangA> */}

            <a className="login_link" id="navigation_mobile_register_button" rel="nofollow" href={loginUrl}>
              {t('a_Log_In')}
            </a>
          </div>

          <div className="last-li">
            <p id="navigation_mobile_languages">{t('Languages')}</p>

            <div className="nav-mobile__group">
              <ul>
                {languageLinks.map((ll) => {
                  return (
                    <li key={ll.lang}>
                      <LangA
                        className="navigation_mobile_ll_link"
                        id={'navigation_mobile_' + ll.lang}
                        href={ll.path}
                        title={ll.languageName}
                      >
                        <CloudflareImage
                          id={'navigation_mobile_' + ll.lang + '_img'}
                          src={ll.flag}
                          alt={ll.languageName}
                          className="country-flag"
                          loading="lazy"
                          decoding="async"
                          width="20"
                          height="17"
                        />
                        {ll.languageName}
                      </LangA>
                    </li>
                  );
                })}
              </ul>
            </div>
          </div>
        </div>
      )}

      {submenu.map(({ title, titleId, dropdownId, items }, index) => (
        <React.Fragment key={dropdownId}>
          {openDropdown === dropdownId && (
            <div id={dropdownId} className="mobile_nav_ul">
              {title ? <p id={titleId}>{title}</p> : <div className={'nav__dropdown-spacer'} />}
              {items &&
                items.map(
                  (
                    {
                      href,
                      img,
                      linkText,
                      subText,
                      title,
                      headId,
                      subTextId,
                      iconId,
                      itemHasDropdown,
                      dropdownId,
                      hasSmallDropdown,
                      subMenu,
                    },
                    idxItem
                  ) => (
                    <React.Fragment key={`submenu_${idxItem}`}>
                      {!hasSmallDropdown && (
                        <div
                          className={`nav__dropdown-list-item mobile_nav_li ${img ? 'nav__dropdown-list-item-img' : ''} ${
                            itemHasDropdown ? 'nav_inner_dropdown' : ''
                          }`}
                        >
                          {img && (
                            <div className="mobile-nav-icon-container">
                              <img id={iconId} className={`nav__dropdown-item-img `} src={img} alt={title} />
                            </div>
                          )}
                          <div className="d-inline-block sublink-div">
                            <LangA
                              id={titleId}
                              href={href}
                              title={title}
                              className={`${itemHasDropdown ? 'main_mobile-link-inner' : 'mobile-link-small'}
                      ${subText ? '' : 'padding-large'}
                      `}
                              onClick={(e) => handleToggle(e, itemHasDropdown, dropdownId)}
                            >
                              {linkText}
                              {itemHasDropdown && (
                                <span>
                                  <CloudflareImage src={RightArrow} height="15" width="9" />
                                </span>
                              )}
                            </LangA>
                            {subText && (
                              <span id={subTextId} className={'nav__dropdown-list-subtext'}>
                                {subText}
                              </span>
                            )}
                          </div>
                        </div>
                      )}
                      {hasSmallDropdown && (
                        <NavListItem
                          key={idxItem}
                          href={href}
                          linkText={linkText}
                          title={title}
                          titleId={titleId}
                          subMenu={subMenu}
                          img={img}
                          iconId={iconId}
                        />
                      )}
                    </React.Fragment>
                  )
                )}
            </div>
          )}
        </React.Fragment>
      ))}

      {subSubmenu.map(({ title, titleId, dropdownId, items, titleHref }, index) => (
        <React.Fragment key={dropdownId}>
          {openDropdown === dropdownId && (
            <div id={dropdownId} className={`mobile_nav_ul`}>
              {title ? (
                titleHref ? (
                  <StyledLink id={titleId} fontWeight="700" color="#606e7b" href={titleHref}>
                    {title}
                  </StyledLink>
                ) : (
                  <p id={titleId}>{title}</p>
                )
              ) : (
                <div className={'nav__dropdown-spacer'} />
              )}
              {items &&
                items.map(({ href, linkText, title, titleId, subMenu }, idxItem) => (
                  <NavListItem key={idxItem} href={href} linkText={linkText} title={title} titleId={titleId} subMenu={subMenu} />
                ))}
            </div>
          )}
        </React.Fragment>
      ))}
    </nav>
  );
};

export default NavMobile;
